/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

import CommunicatorStretch from '../../communicator/stretch/communicator-stretch';
import CommunicatorUtility from '../../communicator/utility/communicator-utility';

/**
 * Komunikátor médií pro Ki-Wi Server.
 */
class MediumCommunicator {
  /**
   * Naparsuje médium z JSON a vloží ho do datového skladu.
   * @param {Object} json Část odpovědi na obsah zařízení s jedním médiem.
   * @param {Store} store
   * @returns {Medium}
   */
  parse(json, store) {
    return store.inject('medium', {
      assetId: null,
      checksum: CommunicatorUtility.parseString(json.md5, { nil: null }),
      id: json.id,
      name: CommunicatorUtility.parseString(json.name, { nil: null }),
      params: this.parseParams(json.params),
      playDuration: CommunicatorUtility.parseTime(json.playLength.timeLength),
      stretchEnum: CommunicatorStretch.parse(json.stretching),
      type: json.type,
      url: json.url,
      volume: CommunicatorUtility.parseVolume(json.volume)
    });
  }

  /**
   * Zpracuje parametry média.
   * @param {Object} [json] Část odpovědi na obsah zařízení s parametry média.
   * @private
   * @returns {DsAttrs|null} Parametry ke vložení do datového skladu.
   */
  parseParams(json) {
    if (!isObject(json)) {
      return null;
    }
    return Object.fromEntries(
      Object.entries(json).reduce((acc, [key, value]) => {
        if (isString(value)) {
          // Dekódování URI, které server provádí.
          // Lze použít jednotné sestavení URI, které automaticky provádí encode.
          // Ušetří místo v datovém skladu.
          acc.push([key, decodeURIComponent(value)]);
        } else if (!isObject(value)) {
          // Zbytek primitivních typů se zkopíruje beze změny.
          acc.push([key, value]);
        }
        return acc;
      }, [])
    );
  }
}

export default MediumCommunicator;
